import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { StoreModule } from '@ngrx/store';

import { ToastModule } from '@libs/src/toast/toast.module';

import { OpportunityStoreService } from '@main-client/src/app/opportunity/opportunity-store.service';
import { OpportunityService } from '@main-client/src/app/opportunity/opportunity.service';

import { opportunityReducer } from '@main-client/src/app/opportunity/opportunity.reducer';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    StoreModule.forFeature('opportunities', opportunityReducer),
    ToastModule,
  ],
  providers: [OpportunityService, OpportunityStoreService],
})
export class OpportunityStoreModule {}
